// ------------------------------------------------------------------
// Folder Upload
// ------------------------------------------------------------------

import { APIClient } from "api/api_helper";
import { Folder_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

const api = new APIClient();

export const folderAttachmentApiService = {
    // SELECT ALL METHOD
    getSelectAllData: (
        searchText?: string | null,
        studyid?: number | null,
        pageNumber: number = 1,
        pageSize: number = 10,
    ) => {
        const payload = {


            studyid: studyid,
            searchtext: searchText || null,
            status: "A",
            pagenumber: pageNumber,
            pagesize: pageSize,
        };
        return api.create(Folder_API.Folder_API + "SelectAll", payload);
    },

    insertData: (payload_data: {
        foldername: string;
        studyid: number;
        parentid?: number | null;
    }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {


            foldername: payload_data.foldername,
            studyid: payload_data.studyid,
            parentid: payload_data.parentid ?? null,
            createdby: user.userid,
        };
        return api.create(Folder_API.Folder_API + "Insert", payload);
    },

    updateData: (payload_data: {
        folderid: number;
        studyid: number | null | undefined;
        foldername: string;
        updatereason: string;
        parentid?: number | null;
    }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {


            folderid: payload_data.folderid,
            studyid: payload_data.studyid,
            foldername: payload_data.foldername,
            parentid: payload_data.parentid ?? null,
            updatedby: user.userid,
            updatereason: payload_data.updatereason,
        };
        return api.create(Folder_API.Folder_API + "Update", payload);
    },

    deleteData: (payload_data: { id: number; updatereason: string }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {


            folderid: payload_data.id,
            updatereason: payload_data.updatereason,
            updatedby: user.userid,
        };
        return api.create(Folder_API.Folder_API + "Delete", payload);
    },
};